import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { CustomerData } from 'interfaces/stripe'

interface UseGetOrganizationCustomerProps {
  organizationId: number | string
  enabled?: boolean
}

const fetchOrganizationCustomer = async (
  organizationId: number | string
): Promise<CustomerData> => {
  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${organizationId}/customer`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  const json = await response.json()

  const customerData = json.customer || json
  return customerData
}

const useGetOrganizationCustomer = ({
  organizationId,
}: UseGetOrganizationCustomerProps) => {
  return useQuery(
    ['organization-customer', organizationId],
    () => fetchOrganizationCustomer(organizationId),
    {
      enabled: !!organizationId,
    }
  )
}

export default useGetOrganizationCustomer
